exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.arrow-svg-chap[data-v-74ae0dab] {\n  margin: auto;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/chapter/chapter-header.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"chapter-header.vue","sourcesContent":["\n.arrow-svg-chap[data-v-74ae0dab] {\n  margin: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74ae0dab","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/chapter/chapter-header.vue
// module id = 295
// module chunks = 0 5 6